<template>
  <v-tooltip :location="location">
    <template #activator="{ props }">
      <v-icon
        v-bind="props"
        :aria-label="$bct(ariaLabel || text)"
        :color="color"
        :icon="icon"
        :size="size"
        aria-hidden="false"
        class="focus-visible"
        role="tooltip"
        tabindex="0"
      />
    </template>

    <span>
      {{ $bct(text) }}
    </span>
  </v-tooltip>
</template>

<script setup>
const $bct = inject('translator');

defineProps({
  ariaLabel: {
    type: String,
    default: null,
  },
  color: {
    type: String,
    default: 'black',
  },
  icon: {
    type: String,
    required: true,
  },
  location: {
    type: String,
    default: 'bottom',
  },
  size: {
    type: String,
    default: '24',
  },
  text: {
    type: String,
    required: true,
  },
});
</script>
